import { createApp } from 'vue'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import { definePreset } from '@primeuix/themes'
import Aura from '@primeuix/themes/aura'
import ToastService from 'primevue/toastservice'
import Tooltip from 'primevue/tooltip'
import 'primeicons/primeicons.css'
import App from './App.vue'
import { preloadLoggedInRoutes, router } from './router'
import { i18n } from './i18n'
import { initClientPortalConfig } from './config/clientPortalConfig'
import { initPageTitleLocaleWatcher } from './utils/pageTitle'
import { useAuthStore, isAuthCallbackPending } from './stores/useAuthStore'
import './styles.css'

var ClientPortalPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#eef4ff',
      100: '#dce8ff',
      200: '#b9d1ff',
      300: '#9cc4ff',
      400: '#5694a4',
      500: '#206aff',
      600: '#1749ad',
      700: '#010031',
      800: '#010031',
      900: '#010031',
      950: '#010031',
    },
  },
})

async function bootstrap() {
  initClientPortalConfig()
  var app = createApp(App)
  var pinia = createPinia()
  app.use(pinia)
  var authStore = useAuthStore()
  if (!isAuthCallbackPending()) {
    await authStore.init()
  }
  app.use(router)
  app.use(i18n)
  initPageTitleLocaleWatcher()
  app.use(PrimeVue, {
    theme: {
      preset: ClientPortalPreset,
      options: {
        darkModeSelector: false,
        cssLayer: {
          name: 'primevue',
          order: 'theme, base, primevue',
        },
      },
    },
  })
  app.use(ToastService)
  app.directive('tooltip', Tooltip)
  await router.isReady()
  app.mount('#app')
  var preload = () => preloadLoggedInRoutes()
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(preload)
    return
  }
  window.setTimeout(preload, 0)
}

bootstrap()
